import { isValidNumber } from "../validator";

export const validField = (name, value) => {
  switch (name) {
    case "title":
      return value.length >= 4;
    case "resume":
      return value.length >= 4;
    case "course":
      return value.length > 0;
    case "price":
      return isValidNumber(parseInt(value, 10)) && parseInt(value, 10) >= 0;
    case "status":
      return value;
    default:
      return true;
  }
};

export const validForm = (fields) => {
  const { title, resume, price, course, status } = fields;
  return (
    parseInt(price.value, 10) >= 0 &&
    title.value.length >= 4 &&
    resume.value.length >= 4 &&
    course.value.length > 0 &&
    status
  );
};
